import { useMemo } from 'react'
import { InputSelectControlField } from '@sequencehq/core-components'
import { QUOTE_DEAL_TYPE_LABELS } from '@sequencehq/quote-content'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
// Imported directly from the types module (rather than the `conditions`
// barrel) to avoid a circular import — see the matching note in formatters.tsx.
import { ConditionValueInputComponent } from 'Automations/nodeDefinitions/conditions/conditions.types'

const DEAL_TYPE_OPTIONS = Object.entries(QUOTE_DEAL_TYPE_LABELS).map(
  ([value, label]) => ({ value, label })
)

/**
 * Picks a quote deal type (e.g. for the `DEAL_TYPE` property's
 * `EQUALS`/`NOT_EQUALS` operators). Options are static — the deal type is a
 * closed enum on the quote model.
 */
export const DealTypeValueInput: ConditionValueInputComponent = ({
  'data-testid': dataTestId,
  value,
  onChange,
  validationErrors
}) => {
  const { useQuoteAmendmentDealType } = useFeatureFlags()

  const options = useMemo(() => {
    return DEAL_TYPE_OPTIONS.filter(option => {
      if (option.value === 'AMENDMENT' && !useQuoteAmendmentDealType)
        return false
      return true
    })
  }, [useQuoteAmendmentDealType])

  return (
    <InputSelectControlField
      data-testid={dataTestId ? `${dataTestId}.value` : undefined}
      value={value ?? ''}
      onChange={next => onChange({ value: next as string })}
      options={options}
      placeholder="Select deal type..."
      validationErrors={
        validationErrors?.map(e => ({ message: e.message })) ?? []
      }
    />
  )
}
